import { Request } from '@/classes/Request.ts'

export const setLocaleCode = async (localeCode: string): Promise<void | string> => {
  return new Promise((resolve, reject) => {
    new Request()
      .post('/ajax/set_locale_code', { locale_code: localeCode })
      .then(() => {
        resolve()
      })
      .catch((err: any) => {
        reject(err)
      })
  })
}
